import { useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import HighlightCard from "../../ui/components/HighlightCard";
import PillButton from "../../ui/components/PillButton";
import CollectionTrendSection from "../statistics/components/CollectionTrendSection";
import { buildTrendByWasteCategory } from "../statistics/utils/collectionChartUtils";
import rotationIcon from "../../static/assets/dashboard-rotation.svg";
import sortingPreviousIcon from "../../static/assets/dashboard-sorting-previous.svg";
import sortingVariationIcon from "../../static/assets/dashboard-sorting-variation.svg";
import {
  formatCount,
  formatVariation,
  readBooleanStorage,
  resolveNumberLocale,
  writeBooleanStorage,
} from "./dashboardKpiUtils";

const STORAGE_KEY = "dashboard.rotationsOpen";
const STATISTICS_COLLECTION_STATE = {
  activateCollectionField: true,
  activateQualityField: false,
  activateCostField: false,
  activateCarbonField: false,
};

export const DashboardRotations = ({
  currentCount,
  previousCount,
  dataResult = {},
  previousDataResult = {},
  statsReady,
}) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const numberLocale = resolveNumberLocale(i18n.language);
  const [isOpen, setIsOpen] = useState(() =>
    readBooleanStorage(STORAGE_KEY, true),
  );
  const trendByWasteCategoryCurrent = useMemo(
    () => buildTrendByWasteCategory(dataResult),
    [dataResult],
  );
  const trendByWasteCategoryPrevious = useMemo(
    () => buildTrendByWasteCategory(previousDataResult),
    [previousDataResult],
  );

  const toggleOpen = () => {
    setIsOpen((current) => {
      const next = !current;
      writeBooleanStorage(STORAGE_KEY, next);
      return next;
    });
  };

  return (
    <section className="dashboard-sorting-errors">
      <div className={`dashboard-sorting-header${isOpen ? " is-open" : ""}`}>
        <button
          type="button"
          className="dashboard-sorting-toggle"
          onClick={toggleOpen}
          aria-expanded={isOpen}
          aria-controls="dashboard-rotations-panel"
        >
          <h3 className="dashboard-campaigns-title">
            {t("dashboard.rotations")}
          </h3>
          <i
            className={`fas fa-chevron-down dashboard-sorting-chevron${isOpen ? " is-open" : ""}`}
            aria-hidden="true"
          />
        </button>
        <PillButton
          size="md"
          onClick={() =>
            history.push({
              pathname: "/statistics",
              state: STATISTICS_COLLECTION_STATE,
            })
          }
        >
          {t("dashboard.viewRotationsDetails")}
        </PillButton>
      </div>
      {isOpen ? (
        <div id="dashboard-rotations-panel" className="dashboard-kpi-panel">
          <div className="dashboard-volume-row">
            <HighlightCard
              iconSrc={rotationIcon}
              title={t("Rotations completed")}
              hint={t("dashboard.rotationsHint")}
              value={formatCount(currentCount, numberLocale)}
            />
            <HighlightCard
              iconSrc={sortingPreviousIcon}
              title={t("dashboard.rotationsPrevious")}
              hint={t("dashboard.rotationsPreviousHint")}
              value={formatCount(previousCount, numberLocale)}
            />
            <HighlightCard
              iconSrc={sortingVariationIcon}
              title={t("dashboard.rotationsVariation")}
              hint={t("dashboard.rotationsVariationHint")}
              value={formatVariation(currentCount, previousCount)}
            />
          </div>
          {statsReady ? (
            <CollectionTrendSection
              className="dashboard-chart-card"
              trendByWasteCategoryCurrent={trendByWasteCategoryCurrent}
              trendByWasteCategoryPrevious={trendByWasteCategoryPrevious}
              t={t}
            />
          ) : null}
        </div>
      ) : null}
    </section>
  );
};
